import { useCallback, useState } from "react"

export type LibraryViewMode = "grid" | "list"

const STORAGE_KEY = "library-view-mode"

function readStoredMode(): LibraryViewMode {
  try {
    return localStorage.getItem(STORAGE_KEY) === "list" ? "list" : "grid"
  } catch {
    return "grid"
  }
}

/** Режим просмотра папки Библиотеки: плитка или список; запоминается между сессиями. */
export function useLibraryViewMode(): [LibraryViewMode, (mode: LibraryViewMode) => void] {
  const [mode, setMode] = useState<LibraryViewMode>(readStoredMode)

  const update = useCallback((next: LibraryViewMode) => {
    setMode(next)
    try {
      localStorage.setItem(STORAGE_KEY, next)
    } catch {
      /* ignore */
    }
  }, [])

  return [mode, update]
}
